import translations from '../config/translations/index';
import {useLanguage} from '../context/LanguageContext';

export function useTranslation() {
  const {lang} = useLanguage();
  return translations[lang];
}
